export default __webpack_public_path__ + "static/media/dropdown-caret.3ea7d78c.svg";